import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { Badge, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { postalAreaAPI_New } from "../../api/apiSystem";
import heroVideo from "../../assets/images/transirox.mp4";
import caddyImg from "../../assets/images/Caddy.png";
import busImg from "../../assets/images/Bus.png";
import maxiBusImg from "../../assets/images/MaxiBus.png";
import shipmentTrip from "../../assets/images/shipmentTrip.png";
import planenbusImg from "../../assets/images/Planenbus.png";
import "./ShipmentAndVehicles.css";
import { FaExclamationTriangle } from "react-icons/fa";

export default function ShipmentAndVehicles({ hideHeader = false }) {
  const { t } = useTranslation();
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000 });
    const fetchVehicles = async () => {
      const res = await postalAreaAPI_New.index();
      if (res.success) {
        console.log("🚀 ~ fetchVehicles ~ res:", res);
        const vehicleList = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.data?.data)
            ? res.data.data
            : [];

        setVehicles(vehicleList);
      } else {
        console.error("Error fetching vehicles:", res.message);
      }
    };

    fetchVehicles();
  }, []);
  const cars = [caddyImg, busImg, maxiBusImg, planenbusImg];
  return (
    <section className="shipment-section py-5">
      <Container>
        {/* First Part - Header Section */}
        {!hideHeader && (
          <Row className="align-items-center justify-content-between mb-5">
            {/* <Col xs={12} md={7} data-aos="fade-right">
              <h2 className="fw-bold mb-3">
                {t("shipmentAndVehicles.trackingTitle")}
              </h2>
              <p className="lead fw-bold">
                {t("shipmentAndVehicles.trackingDescription")}
              </p>
            </Col>
            <Col xs={12} md={5} data-aos="zoom-in">
              <video
                src={heroVideo}
                autoPlay
                loop
                muted
                playsInline
                className="shipment-and-vehicles-video img-fluid object-fit-cover rounded-4 shadow-sm max-h-300"
              />
            </Col> */}

            <Col xs={12} md={12} data-aos="fade-right">
              <img className="shipment-and-vehicles-video img-fluid object-fit-cover rounded-4 shadow-sm max-h-300" src={shipmentTrip} alt={t("shipmentAndVehicles.trackingTitle")} />
            </Col>
          </Row>
        )}

        {/* Second Part */}
        <div className="text-center mb-5">
          <h4 className="text-orange fw-bold">
            {t("shipmentAndVehicles.fleetTitle")}
            &nbsp;
            <span className="text-dark">
              {t("shipmentAndVehicles.fleetTitleHighlight")}
            </span>
          </h4>
        </div>

        <Row className="g-4">
          {Array.isArray(vehicles) &&
            vehicles.map((item, index) => (
              
              <Col
                key={item?.id ?? index}
                xs={12}
                sm={6}
                lg={6}
                data-aos="zoom-in"
                data-aos-delay={index * 150}
              >
                <div className="vehicle-card h-100 p-4 shadow-sm rounded-4 bg-white hover-shadow text-start">

                  <img
                    src={cars[index] || "fallback.jpg"}
                    alt={item?.name}
                    className="img-fluid mb-3 vehicle-img d-block mx-auto"
                  />
                  <h5 className="fw-bold mb-2 text-center">{item.name}</h5>
                  {(item?.first_letter ||
                    item?.second_letter ||
                    item?.third_letter) && (
                    <ul className="small text-muted mb-3">
                      {item?.first_letter && <li>{item.first_letter}</li>}
                      {item?.second_letter && <li>{item.second_letter}</li>}
                      {item?.third_letter && <li>{item.third_letter}</li>}
                    </ul>
                  )}

                  {item?.specifications && (
                    <div className="small text-muted">
                      {item?.specifications?.type && (
                        <p className="mb-1">{item.specifications.type}</p>
                      )}
                      {item?.specifications?.price && (
                        <p className="mb-1">{item.specifications.price}</p>
                      )}
                      {item?.specifications?.duration && (
                        <p className="mb-1">{item.specifications.duration}</p>
                      )}
                      {item?.specifications?.pallets && (
                        <p className="mb-1">{item.specifications.pallets}</p>
                      )}
                      {item?.specifications?.max_weight && (
                        <p className="mb-1">{item.specifications.max_weight}</p>
                      )}
                      {item?.specifications?.dimensions && (
                        <p className="mb-0">{item.specifications.dimensions}</p>
                      )}
                    </div>
                  )}
                </div>
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  );
}
